module.exports = __webpack_public_path__ + "static/media/AI blockly-icon.29b5453e.png";